import { render } from "./pane.vue?vue&type=template&id=0ac6d97c"
import script from "./pane.vue?vue&type=script&lang=js"
export * from "./pane.vue?vue&type=script&lang=js"

import exportComponent from "D:\\www\\Centroid\\Frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__